import React from 'react';

export {
  BUILTIN_LANDING_SKILLS,
  buildLandingSkillChoices,
  DEFAULT_LANDING_CHOICE,
  isLandingSkillEligible,
  LANDING_CHAT_CHOICE,
  LANDING_TABS,
  landingChoiceAllowsMedia,
  landingPlaceholder,
  withoutSkillBuilder,
} from './landingChoices';
export type { LandingBuilderId, LandingChoiceKind, LandingSkillChoice } from './landingChoices';

const DEFAULT_PREFIX = (
  <>
    <span className="landing-brand-headline">Agentic AI</span> factory to build
  </>
);

/** The landing headline. Mode selection moved to the tabs above the text box. */
export const LandingSkillSelector: React.FC<{ prefix?: React.ReactNode }> = ({ prefix = DEFAULT_PREFIX }) => (
  <div className="hero landing-skill-selector">
    <div className="hero__title landing-skill-selector__headline">
      <h1 className="landing-skill-selector__heading">
        <span className="landing-skill-selector__prefix">{prefix}</span>
        <span className="landing-skill-selector__word">:</span>
      </h1>
    </div>
  </div>
);
